export default __webpack_public_path__ + "static/media/SURJEET_KHANNA.dcfdcc07.jpg";